import {
  BooleanField,
  Datagrid,
  ReferenceField,
  // DateField,
  TextInput,
  TextField,
  // SearchInput,
  SelectInput,
  useTranslate,
  NumberField,
  FunctionField,
  // NumberInput,
  // downloadCSV,
} from 'react-admin'
import DownloadIcon from '@mui/icons-material/GetApp'
import { ListBase } from '../../components/base'
// import { NameField, DateField } from '../../components/fields'
import {
  PRODUCTS_TIRE_FIELDS,
  PRODUCTS_COMMON_FIELDS,
  // COMMON_FIELDS,
} from '../../providers/localization/constant'
// import { useExport } from '../../hooks'
import { ExportButton } from '../../components/buttons'
// import jsonExport from 'jsonexport/dist'
import { Product } from '../../types/product'
import { useProductExport } from '../../hooks/useProductExport'
import { ImportButton } from '../../components/buttons/ImportButton'

const TireList = (): JSX.Element => {
  const translate = useTranslate()

  const tireListFilters = [
    // <TextInput
    //   key={0}
    //   source='prod_code'
    //   // InputLabelProps={{ shrink: true }}
    //   // InputProps={{ notched: false }}
    //   // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
    // />,
    // <TextInput
    //   key={1}
    //   source='prod_brand_name'
    //   // InputLabelProps={{ shrink: true }}
    //   // InputProps={{ notched: false }}
    //   // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`)}
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`)}
    // />,
    <TextInput
      key={0}
      source='prod_name'
      label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_name.label`)}
    />,
    <TextInput
      key={1}
      source='prod_brand_code'
      label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`)}
    />,
    // <NumberInput
    //   key={2}
    //   source='sale_price'
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.sale_price.label`)}
    // />,
    // <NumberInput
    //   key={3}
    //   source='promotion_sale_price'
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.promotion_sale_price.label`)}
    // />,
    <SelectInput
      key={4}
      label={`${PRODUCTS_COMMON_FIELDS}.special_flag.label`}
      source='special_flag'
      choices={[
        { id: 'B', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.B` },
        { id: 'H', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.H` },
        { id: 'P', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.P` },
      ]}
    />,
    <SelectInput
      key={5}
      label={`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`}
      source='prod_item_status'
      choices={[
        { id: 'N', name: `${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.N` },
        { id: 'D', name: `${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.D` },
      ]}
    />,
    <SelectInput
      key={6}
      label={`${PRODUCTS_COMMON_FIELDS}.has_slug.label`}
      source='has_slug'
      choices={[
        { id: true, name: `${PRODUCTS_COMMON_FIELDS}.has_slug.choices.true` },
        { id: false, name: `${PRODUCTS_COMMON_FIELDS}.has_slug.choices.false` },
      ]}
    />,
  ]

  const { exporter } = useProductExport(
    translate(`${PRODUCTS_TIRE_FIELDS}.filename`),
    (records: Partial<Product>[]): Partial<Product>[] => {
      const recordsForExport = records.map((record) => {
        return {
          id: record?.prod_code,
          prod_item_status: record?.prod_item_status,
          prod_brand_name: record?.prod_brand_name,
          prod_name_th: record?.prod_name_th,
          sale_price: record?.sale_price,
          price_remark: record?.price_remark, // ***
          promotion_sale_price: record?.promotion_sale_price,
          promotion_remark: record?.promotion_remark, // ***
          green_card_promotion_sale_price: record?.green_card_promotion_sale_price, // ***
          green_card_promotion_remark: record?.green_card_promotion_remark, // ***
          ev_card_promotion_sale_price: record?.ev_card_promotion_sale_price, // ***
          ev_card_promotion_remark: record?.ev_card_promotion_remark, // ***
          is_highlight: record?.is_highlight, // *** true  (check 'Y', 'y', 'N', 'n', 'true', 'false')
          special_flag: record?.special_flag, // *** ENUM 'B' | 'N' | 'P'
          prod_desc_en: record?.prod_desc_en, // ***
          prod_desc_th: record?.prod_desc_th, // ***
          image: record?.image?.name, // *** file รูป
          thumbnail: record?.thumbnail?.name, // *** file รูปthumbnail
          detail_image: record?.detail_image?.name, // *** file รูปรายโบรชัวร์
          video_url: record?.video_url, // ***
          warranty_image: record?.warranty_image?.name, // *** file รูปรายละเอียดประกัน
          tire_speed_rating: record?.tire_speed_rating, // ***
          tire_load_index: record?.tire_load_index, // ***
          tire_treadwear: record?.tire_treadwear, // ***
          tire_traction: record?.tire_traction, // ***
          tire_temperature: record?.tire_temperature, // ***
          tire_characters: record?.tire_characters, // *** (array ตัวอย่าง ['C','Q','S','F','T','D','W'])
          slug_th: record?.slug_th, // ***
          slug_en: record?.slug_en, // ***
        } as unknown as Partial<Product>
      })

      return recordsForExport
    },
  )

  return (
    <ListBase
      exporter={exporter}
      listAction={{
        menuItems: [
          {
            label: `${PRODUCTS_COMMON_FIELDS}.import.title`,
            icon: <DownloadIcon />,
            button: (
              <ImportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.import.title`)}
                variant='contained'
                to={'/import-product/products-tire'}
                key={19}
              />
            ),
            visible: true,
          },
          {
            label: translate(`${PRODUCTS_COMMON_FIELDS}.export.title`),
            icon: <DownloadIcon />,
            button: (
              <ExportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.export.title`)}
                variant='contained'
                key={10}
                maxResults={100000}
              />
            ),
            visible: true,
          },
        ],
      }}
      perPage={50}
      filters={tireListFilters}
      sort={{ field: 'is_highlight', order: 'DESC' }}
    >
      <Datagrid rowClick='show' bulkActionButtons={null}>
        {/* <TextField
          source='prod_code'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_code.label`}
        ></TextField>
        <TextField
          source='prod_brand_name'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`}
        ></TextField>
        <TextField
          source='prod_model_name'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_model_name.label`}
        ></TextField>
        <TextField
          source='prod_model_code'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_model_code.label`}
        ></TextField>
        <NumberField
          source='tire_spec_height'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_spec_height.label`}
          sortable={false}
        ></NumberField>
        <NumberField
          source='tire_spec_width'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_spec_width.label`}
          sortable={false}
        ></NumberField>
        <NumberField
          source='tire_spec_diameter'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_spec_diameter.label`}
          sortable={false}
        ></NumberField>
        <TextField
          source='tire_speed_rating'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_speed_rating.label`}
        ></TextField>
        <TextField
          source='tire_load_index'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_load_index.label`}
        ></TextField>
        <TextField
          source='tire_treadwear'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_treadwear.label`}
        ></TextField>
        <TextField
          source='tire_traction'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_traction.label`}
        ></TextField>
        <TextField
          source='tire_temperature'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_temperature.label`}
        ></TextField>
        <DateField
          source='create_at'
          showTime
          label={`${PRODUCTS_TIRE_FIELDS}.create_at`}
          textAlign='center'
        /> */}
        <BooleanField
          source='is_highlight'
          label={`${PRODUCTS_COMMON_FIELDS}.is_highlight.label`}
          textAlign='center'
        />
        <ReferenceField
          source='special_flag'
          reference='special-flags'
          label={`${PRODUCTS_COMMON_FIELDS}.special_flag.label`}
          sortBy='special_flag'
        >
          <TextField source='title_th'></TextField>
        </ReferenceField>
        <TextField
          source='prod_name_th'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_name_th.label`}
        ></TextField>
        <TextField
          source='prod_name_en'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_name_en.label`}
        ></TextField>
        <TextField
          source='prod_brand_code'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`}
        ></TextField>
        <NumberField
          source='sale_price'
          label={`${PRODUCTS_COMMON_FIELDS}.sale_price.label`}
        ></NumberField>
        <TextField
          source='promotion_sale_price'
          label={`${PRODUCTS_COMMON_FIELDS}.promotion_sale_price.label`}
        ></TextField>
        {/* <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
        /> */}
        <FunctionField
          textAlign='center'
          source='prod_item_status'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`}
          render={({ prod_item_status: status }): string =>
            status === 'N'
              ? translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.N`)
              : translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.D`)
          }
          // sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default TireList
